<template>
    <modal :width="modalWidth" :max_width="modalWidth" class="modal-message">
      <div class="pt-16 pb-12 relative">
        <img class="absolute pin-t pin-r mt-4 mr-5 cursor-pointer"
             src="@/assets/SVG/cross-partners.svg"
             alt="cross-partners.svg"
             @click="$emit('close')"/>
      <div v-if="modal_data.success" class="text-sm lg:text-base">
        <p class="font-bold text-center">Данные статистики успешно отправлены</p>
        <br>
        <p class="font-normal text-center mt-4">По всем вопросам обращайтесь<br> в службу поддержки.</p>
      </div>
      <div v-if="modal_data.reject">
        <p class="mt-2 font-bold text-center lg:text-lg">{{error_header || 'Отправка статистики невозможна!'}}</p>
        <br>
        <p class="font-normal text-center">{{error_text}}</p>
      </div>
      </div>
    </modal>
</template>

<script>
import Modal from '@/views/modals/base-modal';
import ModalMixin from '../../../../../mixins/modals';
import isMobile from '../../../../../mixins/isMobile';

export default {
  name: 'stat_modal_text',
  props: ['modal_data', 'error_text', 'error_header'],
  components: { Modal },
  mixins: [ModalMixin, isMobile],
  computed: {
    modalWidth() {
      if (this.isMobile === 'mobile') {
        return 320;
      }
      return 420;
    },
  },
};
</script>

